<template>
  <div id="app">
    <TabRouter />
  </div>
</template>

<script>
export default {
  name: 'Marubooks',
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  overflow-x: hidden;
}
.md-tabs-container {
  box-sizing: border-box;
}

</style>
